import * as types from "../actionTypes";

export function setCurrentUser(payload) {
  return { type: types.SET_CURRENT_USER, payload };
}

export function updateCurrentUser(payload) {
  return { type: types.UPDATE_CURRENT_USER, payload };
}

export function logUserOut() {
  return { type: types.LOGOUT_USER, payload: "" };
}

export function logoutWithoutLastUser() {
  return { type: types.LOGOUT_USER_LAST_USER, payload: "" };
}

export function loginUserSuccess(payload) {
  return { type: types.LOGIN_USER, payload };
}

export function setLoggedIn(payload) {
  return { type: types.SET_LOGGED_IN, payload };
}

export function newUserReset(payload) {
  return { type: types.NEW_USER_RESET, payload };
}
